(function ($) {
	$.fn.modal = function () {
		let $el;
		let $close;
		let $open;

		const init = function () {
			$close = $el.find('.js-close-modal');
			$open = $('body').find(
				'button[data-modal="' + $el.attr('data-modal') + '"]'
			);

			$open.on('click', function (e) {
				e.preventDefault();
				open();
			});

			$close.on('click', function (e) {
				e.preventDefault();
				close();
			});
		};

		const open = function () {
			// Lock body.
			$('body').css({
				overflowY: 'hidden',
			});

			$('.header').css({
				opacity: 0,
			});

			/**
			 * We also want to add the "curtain" object.
			 * It helps to hide the ugly in prepration for the final reveal.
			 * ... and it looks cool :)
			 */
			const $curtain = $('<div class="modal__curtain"></div>');
			$curtain.insertAfter($el);
			$curtain.one(
				'animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
				function () {
					$curtain.remove();
				}
			);

			/**
			 * While the curtain is on, prepare the modal in the background.
			 */
			$el.delay(500).queue(function (next) {
				$el.addClass('is-active');
				next();
			});
		};

		const close = function () {
			$el.removeClass('is-active');

			$('body').css({
				overflowY: 'auto',
			});

			$('.header').removeAttr('style');
		};

		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).modal();
				});
			} else {
				$el = this;
				init();
			}
		}
	};

	$(document).ready(function () {
		$('.modal').modal();
	});
})(jQuery);
